import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CentralManagementAppComponent }  from './central-management-app.component';
import { APPRoutingModule } from './app.routes';
import { LoginComponent } from './login/login.component';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { TokenInterceptor } from './auth/token.interceptor';
import {VersionDetailsService} from "./version-details/version.details.service";
import {PatientPortalActivitiesFilterService} from "./patient-portal/patient-portal-activities-filter.service";
import {CommonComponentsModule} from "./common/components/common.components.module";
import {FormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {APP_BASE_HREF, CommonModule} from "@angular/common";
import {PatientKioskActivitiesFilterService} from "./patient-kiosk/patient-kiosk-activities-filter.service";

export function baseHrefFactory() {
  const baseResourceUrl = window['__central_management_global_vars__'].baseResourceUrl;
  if (baseResourceUrl === '/') {
    return baseResourceUrl;
  }
  const expectedBaseHref = baseResourceUrl.split('/')[1];
  const currentBaseHref = window.location.pathname.split('/')[1];
  if (expectedBaseHref.toLowerCase() === currentBaseHref.toLowerCase() && expectedBaseHref !== currentBaseHref) {
    // The two base hrefs are the same, but not the same case.
    // Redirect the user to the correct base href.
    const newLocation = window.location.href.replace(currentBaseHref, expectedBaseHref);
    window.location.replace(newLocation);
  }
  return '/' + expectedBaseHref + '/';
}

@NgModule({
    imports: [CommonComponentsModule, BrowserAnimationsModule, APPRoutingModule, FormsModule, HttpClientModule, CommonModule],
    providers: [{provide: APP_BASE_HREF, useFactory: baseHrefFactory},
                { provide: IntlService, useClass: CldrIntlService },
                { provide: HTTP_INTERCEPTORS,
                      useClass: TokenInterceptor,
                      multi: true
                },VersionDetailsService, PatientPortalActivitiesFilterService, PatientKioskActivitiesFilterService
               ],
    declarations:[CentralManagementAppComponent,
                  LoginComponent],
    bootstrap: [CentralManagementAppComponent]
})
export class AppModule { }
